const parseValidationErrors = errors =>
  errors.reduce(
    (r, c) => ({
      ...r,
      ...c.members.reduce(
        (o, member) => ({
          ...o,
          [member]: c.message || `${member} error`,
        }),
        {}
      ),
    }),
    {}
  );

export default parseValidationErrors;
